import { render, staticRenderFns } from "./badges_list.vue?vue&type=template&id=72a91816&scoped=true&"
import script from "./badges_list.vue?vue&type=script&lang=js&"
export * from "./badges_list.vue?vue&type=script&lang=js&"
import style0 from "./badges_list.vue?vue&type=style&index=0&id=72a91816&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a91816",
  null
  
)

export default component.exports